<template>
  <div id="app" class="col-md-5 col-xs-12 col-sm-12 col-12">
    <h1 class="big-title text-left-desktop">{{ $t('m21') }}</h1>
    <p class="description-page md-text-center">
      {{ $t('m22') }}
    </p>
    <form @submit="checkForm">
      <a-input
        :label="$t('labels.email')"
        type="email"
        placeholder="E.: juanperez@email.com"
        name="email"
        class="mt2"
        :error="form.email.error.length > 0"
        :errorMessage="form.email.error"
        v-model="form.email.value"
        @keyup="evaluateInput"
      />

      <vue-recaptcha
        class="step1-recaptcha mt2"
        sitekey="6Lcr_W8mAAAAAI91sHKstTKsDNXJ3hpC8Q74sdKV"
        :loadRecaptchaScript="true"
        @verify="verifyReCaptcha"
        @error="verifyReCaptcha"
      ></vue-recaptcha>

      <a-btn type="submit" class="mt2" primary :loading="loading">{{
        $t('m23')
      }}</a-btn>
    </form>
  </div>
</template>

<script>
import AInput from '@/components/ui/AInput';
import ALink from '@/components/ui/ALink';
import ABtn from '@/components/ui/ABtn';
import { validator } from '@/mixins/validator.js';
import VueRecaptcha from 'vue-recaptcha';

export default {
  components: {
    ALink,
    AInput,
    ABtn,
    VueRecaptcha,
  },
  mixins: [validator],
  data() {
    return {
      verified: false,
      loading: false,
      form: {
        email: {
          value: '',
          error: '',
          rules: [],
        },
      },
    };
  },
  methods: {
    verifyReCaptcha() {
      this.verified = true;
    },
    evalReCaptcha() {
      if (!this.verified) {
        this.$toast.error('Debes completar el reCAPTCHA para continuar');
      }
      return this.verified;
    },
    checkForm(e) {
      if (this.validateForm() && this.evalReCaptcha()) {
        this.loading = true;
        this.$store
          .dispatch('register/resetPassword', this.form.email.value)
          .then(() => {
            this.$router.push({ name: 'FORGET_PASSWORD_MESSAGE' });
          })
          .finally(() => {
            this.loading = false;
          });
      }
      e.preventDefault();
    },
  },
  mounted() {
    this.form.email.rules = [this.rules.required, this.rules.email];
  },
};
</script>
